import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as IconFavourite } from '../../assets/icons/favorite.svg'

import { ReactComponent as HomeIcon } from '../../assets/icons/home.svg'
import { ReactComponent as DashboardIcon } from '../../assets/icons/dashboard.svg'
import { ReactComponent as SearchIcon } from '../../assets/icons/search.svg'

import { authUserInfo, getUserInfo, sumTotalFavourites } from '../helpers/Util'
import { useFavourite } from '../redux_toolkit/Favourite'
import Image from '../common/Image'

const MobileBottomMenu = ({
    activeMenu,
    setActiveMenu,
    setIsShowProfileMenu,
    isShowProfileMenu,
    setIsShowSearch,
    isShowSearch
}) => {
    const [scrollDirection, setScrollDirection] = useState(null)
    const [lastScrollTop, setLastScrollTop] = useState(0)
    const favouriteStore = useFavourite()

    const navigate = useNavigate()
    useEffect(() => {
        const elementOnQuote = document.getElementById('on-quote')
        const elementQuote = document.getElementById('qoute')
        const elementBigQuote = document.getElementById('quote-big')
        const elementMobile = document.getElementById('mobile-footer')
        const elementDraft = document.getElementById('draft')
        if (
            (elementOnQuote ||
                elementQuote ||
                elementBigQuote ||
                elementDraft) &&
            elementMobile
        ) {
            elementMobile.classList.add('hide-mobile-footer')
        } else {
            elementMobile.classList.remove('hide-mobile-footer')
        }
    }, [lastScrollTop])

    useEffect(() => {
        let ticking = false
        let lastKnownScrollPosition = 0

        const handleScroll = () => {
            lastKnownScrollPosition = window.scrollY

            if (!ticking) {
                window.requestAnimationFrame(() => {
                    if (lastKnownScrollPosition > lastScrollTop) {
                        setScrollDirection('down')
                    } else if (lastKnownScrollPosition < lastScrollTop) {
                        setScrollDirection('up')
                    }

                    setLastScrollTop(Math.max(0, lastKnownScrollPosition))
                    ticking = false
                })

                ticking = true
            }
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [lastScrollTop])

    const setMobileActiveMenue = (activemanue) => {
        navigate(activemanue)
        setActiveMenu(activemanue)
    }

    function renderFavoriteCount() {
        const totalFavourites = sumTotalFavourites(
            favouriteStore?.counts?.style
        )

        return (
            <span className='count absolute w-[18px] h-[18px] top-[-4px] right-[-8px] flex items-center justify-center text-[10px] text-white-shade-100 bg-primaryColor inline-block rounded-[20px] text-center'>
                {totalFavourites > 99 ? '99+' : totalFavourites}
            </span>
        )
    }

    return (
        <>
            <div
                id='mobile-footer'
                className={`mobile-footer ${
                    scrollDirection === 'down' ? 'scrolled' : ''
                }`}
            >
                <ul className='footer-items'>
                    <li
                        className={
                            activeMenu === '' &&
                            !isShowSearch &&
                            !isShowProfileMenu
                                ? 'home active'
                                : 'home'
                        }
                        onClick={() => {
                            setMobileActiveMenue('/design-lab')
                            setIsShowSearch(false)
                        }}
                    >
                        <HomeIcon />
                        <p>Home</p>
                    </li>
                    <li
                        className={isShowSearch ? 'search active' : 'search'}
                        onClick={() => setIsShowSearch(true)}
                    >
                        <SearchIcon />
                        <p>Search</p>
                    </li>
                    <li
                        className={
                            activeMenu === 'favourites' &&
                            !isShowSearch &&
                            !isShowProfileMenu
                                ? 'favourites relative active'
                                : 'favourites relative'
                        }
                        onClick={() => {
                            setMobileActiveMenue('/favourites')
                            setIsShowSearch(false)
                        }}
                    >
                        <IconFavourite />
                        <p>Favorite</p>
                        {renderFavoriteCount()}
                    </li>

                    <li
                        className={
                            activeMenu === 'dashboard' &&
                            !isShowSearch &&
                            !isShowProfileMenu
                                ? 'dashboard active'
                                : 'dashboard'
                        }
                        onClick={() => {
                            setMobileActiveMenue(
                                '/dashboard?active=QUOTES&status=RUNNING'
                            )
                            setIsShowSearch(false)
                        }}
                    >
                        <DashboardIcon />
                        <p>Dashboard</p>
                    </li>

                    <li
                        className={
                            isShowProfileMenu && !isShowSearch
                                ? 'profile active'
                                : 'profile'
                        }
                    >
                        <div
                            className='profile-interaction w-[24px] h-[24px] rounded-full bg-primaryColor-shade-300 relative border border-white-shade-100 flex items-center justify-center cursor-pointer'
                            onClick={() => {
                                setIsShowProfileMenu((prev) => !prev)
                                setIsShowSearch(false)
                            }}
                        >
                            {!authUserInfo()?.profilePicDocument?.docUrl && (
                                <span className='name-icon'>
                                    {getUserInfo()
                                        ?.name?.toUpperCase()
                                        ?.charAt(0)}
                                </span>
                            )}
                            {authUserInfo()?.profilePicDocument?.docUrl && (
                                <Image
                                    src={
                                        authUserInfo()?.profilePicDocument
                                            ?.docUrl
                                    }
                                    className='object-cover object-top w-full h-full rounded-full'
                                    alt=''
                                    isStatic={false}
                                />
                            )}
                        </div>
                        <p>Profile</p>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default MobileBottomMenu
